// extracted by mini-css-extract-plugin
export default {"searchByDescriptionContainer":"systemHistorySearchByDescription_searchByDescriptionContainer__Wfe0c"};